// extracted by mini-css-extract-plugin
export default {"recos":"O6-z","productCardOverride":"P6-z","rowHasBadge":"Q6-z"};